import React from 'react'

import { NavLink } from 'react-router-dom'

export interface HubCardProps {
  path: string
  label: string
  desc: string
  icon: React.ReactNode
  shortcutKey?: string
}

export function HubCard({ path, label, desc, icon, shortcutKey }: HubCardProps): React.ReactElement {
  return (
    <NavLink
      className="group relative flex items-start gap-4 rounded-xl border border-border bg-surface p-5 hover:border-primary/40 hover:shadow-sm transition-all duration-150"
      to={path}
    >
      <div className="flex-shrink-0 w-10 h-10 rounded-lg bg-primary/10 text-primary flex items-center justify-center group-hover:bg-primary/15 transition-colors">
        {icon}
      </div>
      <div className="min-w-0 flex-1">
        <p className="text-sm font-semibold text-foreground group-hover:text-primary transition-colors">{label}</p>
        <p className="text-xs text-muted-foreground mt-0.5 leading-relaxed">{desc}</p>
      </div>
      {shortcutKey && (
        <kbd className="absolute top-3 right-3 inline-flex items-center text-[10px] font-mono text-muted-foreground/50 bg-muted/40 border border-border/40 rounded px-1.5 py-0.5 leading-none select-none">
          {shortcutKey}
        </kbd>
      )}
    </NavLink>
  )
}
